import React from "react";
import { Card, Container } from "react-bootstrap";
import "./recordCard.css";

const RecordCard = (props) => {
  return (
    <Container className="d-flex flex-column justify-content-center mx-auto" style={{maxWidth:"400px"}} >
      
        <p style={{ color: "gray" }} className="mb-0">新增日期:{props.date.replace(/-/g, "/")}</p>
        <Card
          className="shadow-sm d-flex flex-row mx-1 p-3 recordCard-card"
        >
          
          <div style={{ flex: "4" }} className="d-flex justify-content-center align-items-center">
            <Card.Img
              variant="top"
              src={props.image}
              style={{ width: "100%", objectFit: "contain", maxWidth:"100px" }}
              
            />
          </div>
          <div
            style={{ flex: "12" }}
            className="d-flex flex-column justify-content-center align-items-center"
          >
            <p className="memberRecord-type">
              <b>{props.type}</b>
            </p>
            <p className="memberRecord-name">
              <b style={{ color: "#00867F" }} >
                {props.name}
              </b>
            </p>
          </div>
        </Card>
      
    </Container>
  );
};

export default RecordCard;
